import { Bar, mixins } from 'vue-chartjs'

const color = (opacity) => (e) => {
    if (e.percentage < 66) {
        return `rgba(214, 0, 0, ${opacity})`
    } else if (e.percentage >= 66 && e.percentage < 80) {
        return `rgba(244, 99, 0, ${opacity})`
    } else {
        return `rgba(68, 222, 40, ${opacity})`
    }
}

export default {
    extends: Bar,
    mixins: [mixins.reactiveProp],

    props: ['chartData'],

    data: () => ({
        options: {
            legend: {
                labels: {
                    fontColor: 'black',
                    fontFamily: "'Roboto', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                }
            },

            tooltips: {
                backgroundColor: '#00796B',
                titleFontFamily: "'Roboto', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                titleFontSize: 16,
                titleFontStyle: 'normal',
                titleSpacing: 4,
                bodyFontFamily: "'Roboto', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                bodyFontSize: 14,
                xPadding: 8,
                yPadding: 8,
                corderRadius: 4,
                callbacks: {
                    label(tooltipItem) {
                        return tooltipItem.yLabel + '%'
                    }
                }
            },

            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                    }
                }]
            }
        },
    }),

    mounted() {
        this.renderChart({
            labels: this.chartData.map(e => e.field),

            datasets: [{
                label: 'Pendalaman',
                backgroundColor: this.chartData.map(color(0.4)),
                borderColor: this.chartData.map(color(0.7)),
                hoverBackgroundColor: this.chartData.map(color(1)),
                borderWidth: 3,

                data: this.chartData
                    .map(e => Math.round(e.correct_answers / e.total_questions * 100)),
            }]
        }, this.options)
    }
}
